/* global femcare, Swiper */

femcare.product.panel.media = {
    thumbnailGallery: null,
    mainGallery: null,

    init: function () {
        this.initThumbnailGallery();
        this.initMainGallery();
    },

    initThumbnailGallery: function () {
            var slideCount = $('.product-main__slide').length;
            var thumbnailWrapper = $('.product-main__thumbnails-wrapper');

        if (slideCount > 1) {

            this.thumbnailGallery = new Swiper(thumbnailWrapper[0], {
                slidesPerView: 'auto',
                spaceBetween: 20,
                watchSlidesProgress: true,
                direction: 'horizontal',
                allowTouchMove: true,
                watchOverflow: true,
                navigation: {
                    nextEl: '.product-main-nav-button--next',
                    prevEl: '.product-main-nav-button--previous',
                }
            });
        } else {
            $('.product-main__gallery-nav').hide();
        }
    },

    initMainGallery: function () {
        var $gallery = $('.product-main__gallery');
        var galleryWrapper = $('.product-main__gallery');
        

        if ($gallery.length) {

            var normalZoomRatio = 1;
            var maxZoomRatio = 2;

            this.mainGallery = new Swiper(galleryWrapper[0], {
                slidesPerView: 1,
                direction: 'horizontal',
                spaceBetween: 0,
                zoom: {
                    maxRatio: maxZoomRatio
                },
                lazy: {
                    loadPrevNext: true,
                },
                noSwiping: true,
                noSwipingClass: 'product-main__slide--360',
                loop: true,
                on: {
                    transitionStart: function (swiper) {
                        swiper.zoom.out();
                    },
                    zoomChange: function (swiper, scale, imageEl) {
                        var $imageEl = $(imageEl);

                        if (scale > normalZoomRatio) {
                            $imageEl.find('.product-main__image--standard').hide();
                            $imageEl.find('.product-main__image--large').show();
                        } else {
                            $imageEl.find('.product-main__image--large').hide();
                            $imageEl.find('.product-main__image--standard').show();
                        }
                    }
                },
                thumbs: {
                    swiper: this.thumbnailGallery || null
                }
            });

            $('.product-main-nav-button--next').on('click', function () {
                this.mainGallery.slideNext();
            }.bind(this));

            $('.product-main-nav-button--previous').on('click', function () {
                this.mainGallery.slidePrev();
            }.bind(this))
        }
    }
};

